import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-shared-button-component',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatIconModule, MatTooltipModule],
  templateUrl: './shared-button.component.html',
  styleUrls: ['./shared-button.component.scss']
})
export class ButtonSharedComponent implements OnInit {
  @Input() buttonName: string;
  @Input() disableButton: boolean;
  @Input() caller: ButtonCaller;
  @Input() toolTip: string;
  @Input() variant : 'primary' | 'secondary' | 'tertiary' = 'primary';

  constructor() { }

  ngOnInit(): void { }

  executeCaller(): void {
    this.caller();
  }
}

export type ButtonCaller = () => void;